import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { apiKey, password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password, apiKey] as const

export type rlcaCredType = (typeof credentialTypes)[number]
export const rlcaDocumentTypes = [
  'delivery-photo',
  'invoice',
  'letter-of-authority',
  'nmfc-certificate',
  'proof-of-delivery',
  'signed-bol',
  'weight-cert',
] as const satisfies readonly DocumentType[]

export const rlca: CarrierDef<rlcaCredType> = {
  name: 'R+L Carriers',
  scac: 'rlca',
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    {
      id: 'guaranteed_five_pm',
      name: 'Guaranteed by 5pm',
      guaranteed: true,
      guaranteedByTime: '17:00',
    },
    {
      id: 'guaranteed_twelve_pm',
      name: 'Guaranteed by Noon',
      guaranteed: true,
      guaranteedByTime: '12:00',
    },
  ],
  credentialTypes,
  legacyCredMap: [...userPassMap, ['api-key', 'apiKey']],
  engineLayers: [
    'provisioning',
    'rating',
    'bol',
    'pickup',
    'cancel',
    'profinder',
    'tracking',
    'documents',
  ],
  documentTypes: rlcaDocumentTypes,
}
